import script from "./DrfSyncDataTableMixin.vue?vue&type=script&lang=js"
export * from "./DrfSyncDataTableMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__